var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { computed, ref } from "vue";
import { upgradeForm, upgradeFormDataToPayload } from "@/components/ConfigTemplates/formUtil";
import { errorMessageAsString } from "@/utils/simple-error";
import { useInstanceRouting } from "./routing";
import { update } from "./services";
import InstanceForm from "@/components/ConfigTemplates/InstanceForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpgradeForm',
    props: {
        instance: null,
        latestTemplate: null
    },
    setup(__props) {
        const props = __props;
        const error = ref(null);
        const inputs = computed(() => {
            const realizedInstance = props.instance;
            const realizedLatestTemplate = props.latestTemplate;
            const form = upgradeForm(realizedLatestTemplate, realizedInstance);
            return form;
        });
        const title = computed(() => `Upgrade File Source ${props.instance.name}`);
        const submitTitle = "Update Settings";
        const loadingMessage = "Loading file source template and instance information";
        function onSubmit(formData) {
            return __awaiter(this, void 0, void 0, function* () {
                const payload = upgradeFormDataToPayload(props.latestTemplate, formData);
                const args = { user_file_source_id: String(props.instance.uuid) };
                try {
                    const { data: fileSource } = yield update(Object.assign(Object.assign({}, args), payload));
                    yield onUpgrade(fileSource);
                }
                catch (e) {
                    error.value = errorMessageAsString(e);
                    return;
                }
            });
        }
        const { goToIndex } = useInstanceRouting();
        function onUpgrade(fileSource) {
            return __awaiter(this, void 0, void 0, function* () {
                const message = `Upgraded file source ${fileSource.name}`;
                goToIndex({ message });
            });
        }
        return { __sfc: true, error, props, inputs, title, submitTitle, loadingMessage, onSubmit, goToIndex, onUpgrade, BAlert, InstanceForm };
    }
});
